import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

// Custom hook to fetch page content
export const usePageContent = (pageId) => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API_URL}/page-content/${pageId}`);
        // Convert array to object keyed by section_id
        const contentMap = {};
        response.data.forEach(item => {
          contentMap[item.section_id] = item.content;
        });
        setContent(contentMap);
      } catch (error) {
        console.error(`Failed to fetch content for ${pageId}:`, error);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [pageId]);

  // Helper to get content with fallback
  const getContent = (sectionId, fallback = '') => {
    return content[sectionId] || fallback;
  };

  return { content, loading, getContent };
};

// Helper to render HTML content safely
export const renderHTML = (html) => {
  if (!html) return null;
  // Check if the content contains HTML tags
  if (/<[a-z][\s\S]*>/i.test(html)) {
    return <span dangerouslySetInnerHTML={{ __html: html }} />;
  }
  return html;
};
